/* Decades — announcement bar countdown.
 *
 * Counts down to the next order-processing batch cutoff (every 4 hours, ET) —
 * the same clock the cart drawer ETA script (decades-cart-eta.js) uses — so
 * the two timers always agree, and the countdown rolls to the next batch when
 * it hits zero.
 */
(function () {
  'use strict';

  var CUTOFF_INTERVAL_H = 4; // batch cutoffs at 00/04/08/12/16/20 ET

  function nowET() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
  }

  function msUntilCutoff() {
    var et = nowET();
    var cutoff = new Date(et);
    var nextHour = (Math.floor(et.getHours() / CUTOFF_INTERVAL_H) + 1) * CUTOFF_INTERVAL_H;
    cutoff.setHours(nextHour, 0, 0, 0);
    return cutoff - et;
  }

  function fmt(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
  }

  function start() {
    var el = document.querySelector('.dv2-announcement__timer-value');
    if (!el) return;
    var tick = function () { el.textContent = fmt(msUntilCutoff()); };
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
